import { CommentInput } from './CommentInput';
import { CommentsList } from './CommentsList';
import type { CommentsProps } from './types';

export type { CommentsProps } from './types';
export { type GenericComment, LifecycleAction, type LifecycleActionType } from './types';

export const Comments = ({
  disablePost,
  postComment,
  comments,
  inputIdSuffix,
  updateComment,
  disabledInternalComments,
  handleLifecycleClick,
  canModerateAllPosts,
  contactId,
}: CommentsProps) => {
  return (
    <div className="flex flex-col gap-2" data-testid="tempo-comments">
      {!disablePost && (
        <CommentInput
          key={inputIdSuffix}
          onSubmit={postComment}
          inputIdSuffix={inputIdSuffix}
          disabledInternalComments={disabledInternalComments}
        />
      )}
      <CommentsList
        comments={comments ?? []}
        updateComment={updateComment}
        handleLifecycleClick={handleLifecycleClick}
        canModerateAllPosts={canModerateAllPosts}
        contactId={contactId}
      />
    </div>
  );
};
